import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Components
import ActionButton from "../../../Button/ActionButton";
import LayoutWithList from "../../../LayoutModal/WithList";
import Loading from "../../../Loading";
//hooks
import { useEffect } from "react";
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from "../../../../hooks/useLoading";
//Interfaces
import { ICreate } from "Interfaces/ICreate";
import { Inputs } from "Interfaces/ISensitivity";
export default function Update({
  isOpenModal,
  setModalClose,
  refreshFrames,
  selectedUrlId,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(
        `sensitivity/${selectedUrlId}`
      );

      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModal && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModal, selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = {
        ...data,
        sensitivity: data.sensitivity.toLocaleUpperCase(),
      }
      const response = await apiRequest(
        `sensitivity/${selectedUrlId}`,
        "PUT",
        payload
      );
      const status = response.status;
      if (status === 200) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        setModalClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  if (isOpenModal) {
    return (
      <LayoutWithList
        title="Atualizar Fotossensibilidade"
        subTitle="Atualize as informações da fotossensibilidade em sua base de dados."
        setModalClose={setModalClose}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Fotossensibilidade
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe a sensibilidade"
                  type="text"
                  {...register("sensitivity", { required: true })}
                />
                {errors.sensitivity && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.ContentButton>
                <ActionButton
                  name="Atualizar"
                  onClick={handleFormSubmit(onSubmit)}
                />
              </S.ContentButton>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutWithList>
    );
  }
  return null;
}
